import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";
import { AnalyticsReportTab } from "../../models/analytics-report-tab.model";

// NOTE: despite the "projects-at-a-glance" name, this now hosts the full tabbed
// Clinical Operations Dashboard. Project At-a-Glance is the default first tab.
@Component({
  selector: "app-risk-clinical-operations-dashboard-projects-at-a-glance",
  templateUrl: "./risk-clinical-operations-dashboard-projects-at-a-glance.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RiskClinicalOperationsDashboardProjectsAtAGlanceComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_PROJECTS_AT_A_GLANCE;
  hideFilters = [HideFilters.PROJECT_ID, HideFilters.ORG_ID, HideFilters.USER_ID,
                 HideFilters.PROJECT_NAME, HideFilters.PROJECT_NAME2, HideFilters.ORGANIZATION_NAME];
  reportTabs: AnalyticsReportTab[] = [
    { label: "Project At-a-Glance", dashboardType: LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_PROJECTS_AT_A_GLANCE },
    { label: "Coding Accuracy", dashboardType: LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_CODING_ACCURACY },
    { label: "Coding Productivity", dashboardType: LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_CODING_PRODUCTIVITY },
    { label: "QA Error Trends", dashboardType: LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_QA_ERROR_TRENDS },
    { label: "View Details by Chase", dashboardType: LookerRiskDashboardType.RISK_CLINICAL_OPERATIONS_DASHBOARD_CLINICAL_ACCURACY_BY_CHASE },
  ];
}
